import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { UserAccess } from 'components/user-access';
import { PageRestricted } from 'pages/errors/page-restricted';
import { DocumentTypesListing } from 'pages/documents/settings/document-types';
import { AllDocumentsListing } from 'pages/documents/settings/all-documents';
import { Layout } from 'pages/documents/settings/Layout';
import { useDocumentSettings } from 'pages/documents/settings/shared';

export function DocumentSettings(props) {

    const { defaultPath } = useDocumentSettings();

    return (
        <UserAccess perform={["Documents:View"]}
            yes={() => (
                <Layout breadcrumbs={props.breadcrumbs} defaultPath={defaultPath}>
                    <Routes>
                        <Route path="types" element={<DocumentTypesListing />} />
                        <Route path="documents" element={<AllDocumentsListing />} />
                        <Route path="" element={<Navigate to={defaultPath} replace />} />
                    </Routes>
                </Layout>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}